<template>
<div>
  <header class="toolbar">
    <div class="l-container">
      <div class="toolbar__group">
        <c-level>
          <template slot="left">
            <h1 class="toolbar__title">My Profile</h1>
          </template>
        </c-level>
      </div>
    </div>
  </header>
  <c-panel class="l-container">
    <c-row>
      <c-col></c-col>
      <c-col>
        <nav class="navbar">
          <div class="navbar__start">
          </div>
          <div class="navbar__end">
            <a class="navbar__item" v-tooltip="'Write Changes'"><i class="icon-floppy-disk u-h4 u-color-success"></i><span class="u-color-success u-ml-5">SAVE CHANGES</span></a>
            <a class="navbar__item" v-tooltip="'Change Password'" @click="onChangePassword"><i class="icon-eye-blocked u-h4 u-color-success"></i><span class="u-color-success u-ml-5">CHANGE PASSWORD</span></a>
          </div>
        </nav>
        <c-form-field label="User name:">
          <c-form-input v-model="userData.name" />
        </c-form-field>
        <c-form-field label="Login:">
          <c-form-input readonly v-model="userData.login" />
        </c-form-field>
        <c-form-field label="Registered email:">
          <c-form-input readonly v-model="userData.email" />
        </c-form-field>
        <c-form-field label="Client:">
          <c-form-input readonly v-model="userData.client" />
        </c-form-field>
      </c-col>
      <c-col></c-col>
    </c-row>
  </c-panel>
  <ChangePassword ref="chp"></ChangePassword>
</div>
</template>
<script>

import ChangePassword from './ChangePassword'
import axios from 'axios'
import { EventBus } from '../event-bus.js'

export default {
  name: 'UserProfile',
  components: {
    ChangePassword
  },
  data () {
    return {
      userData: {
        name: '',
        login: '',
        client: '',
        email: ''
      }
    }
  },
  mounted () {
    EventBus.$emit('show-loading')
    axios.get(process.env.API + 'user/profile', {
      headers: {
        'Authorization': window.sessionStorage.getItem('token')
      }
    }).then((response) => {
      this.handleData(response.data)
      EventBus.$emit('hide-loading')
    }).catch((reason) => {
      console.error('Could not get data')
      console.error(reason)
      EventBus.$emit('hide-loading')
      this.$snotify.error(
        'Could not load data',
        null,
        {
          position: 'centerTop',
          timeout: 3000,
          showProgressBar: false
        }
      )
    })
  },
  methods: {
    onChangePassword () {
      this.$refs.chp.show()
    },

    handleData (data) {
      this.userData.name = data.name
      this.userData.login = data.username
      this.userData.client = data.clientname
      this.userData.email = data.email
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/UserProfile.vue